import { SET_LOGIN_USER, SET_LOGIN_FLAG,SET_COUNTRY, SET_LOGINUSERTYPE } from '../../actions/types/types';

const initState = {
  loginUser: {},
  loginUserType : "",
  country:"",
  loginFlag: false, // shuold be true later on but for now keep it false
};

const LoginReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_LOGIN_USER:
      return {
        ...state,
        loginUser: action.payload.data,
      };
    case SET_LOGIN_FLAG:
      return { ...state, loginFlag: action.payload.data };
    case SET_COUNTRY:
      return { ...state, country: action.payload.data };
    case SET_LOGINUSERTYPE:
      return { ...state, loginUserType: action.payload.data };
    default:
      return { ...state };
  }
};

export default LoginReducer;
